import { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useStrategyMapService } from '../../services/strategyMap';
import { StrategyEntityItemType } from '../../services/strategyMap';
import store from '../../redux/store';
import { setCurrentSMap } from '../../redux/slices/strategyMapView';

export const useSingleSmapFetch = (strategyMapId: string, config?:{
  cached?: boolean,
  beforeLoad?:()=>any,
  onLoad?:()=>any
}) => {

  const shouldCache = config?.cached != false;
  const dispatch = useDispatch();

  const {  fetchSingleStrategyMap } = useStrategyMapService();
  
  const [state, setState] = useState<{
    loading: boolean;
    data: StrategyEntityItemType | null;
    error: any;
  }>({
    loading: true,
    data: null,
    error: null,
  });

  const loadSingleStrategyMap = useCallback(async (
    strategyMapId: string,
    hardRefresh?: boolean,
   
  ) => {
    try {
      setState((pv) => ({
        ...pv,
        loading: true,
        
      }));
      
      config?.beforeLoad?.();
      const data = await fetchSingleStrategyMap(
        strategyMapId,
        hardRefresh
      );

      config?.onLoad?.();
      setState((pv)=>({
        ...pv,
        loading: false,
        data,
        error: null,
      }));

      if(shouldCache) dispatch(setCurrentSMap(data))
    } catch (err) {
      console.error('Error loading level smaps:', err);
      setState((pv)=>({
        ...pv,
        loading: false,
        error: err,
      }));
    }finally{
      setState((pv)=>({
        ...pv,
        loading: false,
      }));
    }
  }, []);

  useEffect(() => {

  //  const cachedData = store.getState().strategyMapView.strategyMapData;
    if (strategyMapId) {
      // if (cachedData && config?.cached) {
      //   setState((pv:any)=>({
      //     ...pv,
      //     loading: false,
      //     data: cachedData,
      //     error: null,
      //   }));
      //   return;
      // }
      loadSingleStrategyMap(strategyMapId);
    }
  }, [strategyMapId]);


 
  return {
    ...state,
    loadSingleStrategyMap,
  };
};
